import { useEffect } from 'react';

const APP_STORE_URL = 'https://app.nuraemobility.co.in/?c=YImSUF';
const PLAY_STORE_URL = 'https://app.nuraemobility.co.in/?c=YImSUF';
const ANDROID_PACKAGE = 'in.co.nuraemobility.nuraApplication';

// Android Intent URL — launches the app's main launcher activity directly
// Uses action.MAIN + category.LAUNCHER which is the standard way to open an installed app
const ANDROID_INTENT_URL = `intent://#Intent;action=android.intent.action.MAIN;category=android.intent.category.LAUNCHER;package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;

// /appopen — tries to open the already-installed Nura app
export default function AppOpenPage() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    if (isIOS) {
      // No URI scheme yet — fallback to App Store
      // Once you have the URI scheme (e.g. nura://), replace below with:
      // window.location.replace('nura://');
      // setTimeout(() => window.location.replace(APP_STORE_URL), 1500);
      window.location.replace(APP_STORE_URL);
    } else if (isAndroid) {
      // Opens app if installed → auto-falls back to Play Store if not
      window.location.replace(ANDROID_INTENT_URL);
    } else {
      document.title = 'Open Nura';
    }
  }, []);

  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /android/i.test(ua);
  const isMobile = isIOS || isAndroid;

  if (isMobile) return null;

  // Desktop fallback UI
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '32px',
      padding: '24px',
    }}>
      <img
        src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/279asuc7_white%20black%20logo.png"
        alt="NURA"
        style={{ height: '64px', width: 'auto' }}
      />
      <p style={{ color: '#fff', fontSize: '18px', textAlign: 'center' }}>
        Open the Nura app on your device
      </p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/hi2yb4wg_App%20Store.png"
            alt="Download on the App Store"
            style={{ height: '52px', width: 'auto' }}
          />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/bqk1ja7h_Play%20Store.png"
            alt="Get it on Google Play"
            style={{ height: '52px', width: 'auto' }}
          />
        </a>
      </div>
    </div>
  );
}
